import { endOfDay, startOfDay } from "date-fns";
import { TDailyScheduleEntryDto } from "../../../../services/schedulers/types";
import { groupByTyped } from "../../../../utils/arrayUtils";
import { TDailySchedule, TDailyScheduleEntry } from "../types";
import { TDailyScheduleEntryExtensions } from "./TDailyScheduleEntryExtensions";

export class TDailyScheduleExtensions {
    static fromDtos(items: TDailyScheduleEntryDto[]): TDailySchedule[]  {
        var grouped = groupByTyped(items, 'weekday');
        let res: TDailySchedule[] = []
        for (let i = 0; i < 7; i++) {
            const existing = grouped.find(v => v.key === i);
            if (existing) {
                const entries: TDailyScheduleEntryDto[] = existing.values as TDailyScheduleEntryDto[];
                const itemsWithEmpty = TDailyScheduleEntryExtensions.fromDtos(entries,existing.key)
                res.push({ weekday: existing.key, entries: itemsWithEmpty })
            }
            else
                res.push({ weekday: i, entries: [{ weekday: i, start: startOfDay(new Date()), end: endOfDay(new Date()), value: null, id: `${i}_def_1`, isDefault: true }] })
        }
        return res;
    }

    static toDtos(days: TDailySchedule[]): TDailyScheduleEntryDto[]  {
        return TDailyScheduleEntryExtensions.toDtos(days.flatMap(v => v.entries))
    }

    static updateItem(day: TDailySchedule, item: TDailyScheduleEntry) {
        day.entries = TDailyScheduleEntryExtensions.updateItem(day.entries,item);
        return day;
    }

    static deleteItem(day: TDailySchedule, item: TDailyScheduleEntry)  {
        day.entries = TDailyScheduleEntryExtensions.deleteItem(day.entries,item);
        return day;
    }

    static addItem(day: TDailySchedule, item: TDailyScheduleEntry)  {
        day.entries = TDailyScheduleEntryExtensions.addItem(day.entries,item);
        return day;
    }

    static addItems (weeklySchedule: TDailySchedule[], timeFrom: Date, timeTo: Date, value: number | boolean | undefined | null, days: boolean[]): TDailySchedule[] {
        let newDays = [...weeklySchedule];
        for (let i = 0; i < days.length; i++) {
            const weekDayNr = i + 1 >= 7 ? 0 : i + 1;
            if (days[i] === true) {
                const day = newDays.find(v => v.weekday === weekDayNr);
                if (!day)
                    return weeklySchedule;
    
                const dayIndex = newDays.indexOf(day);
                const updateDay = TDailyScheduleExtensions.addItem(day,  {
                    id: `${day.weekday}_${day.entries.length + 1}`,
                    start: timeFrom,
                    end: timeTo,
                    value: value,
                    isDefault: false,
                    weekday: day.weekday
                });
                newDays[dayIndex] = updateDay
            }
        }
        return newDays;
    };
}


